import { useState, useEffect } from "react";
import "./styles.css";

import Map from "./Map";
import Clue1 from "./Clue1";
import Curtis from "./Kurtis/Curtis";
import Frank from "./Frank/Frank";
import Davis from "./Davis/Davis";
import Matt from "./Matt/Matt";
import Aj from "./Aj/Aj";
import Caves from "./Caves/Caves";
import Greg from "./Greg/Greg";
import Final from "./Final";
import Wizard from "./Wizard";

// Notification component
function Notification({ message, type = "info", onClose }) {
  if (!message) return null;

  return (
    <div className={`notification ${type}`}>
      <span>{message}</span>
      <button onClick={onClose}>×</button>
    </div>
  );
}

export default function Unlock() {
  const [activeTab, setActiveTab] = useState("map");
  const [solvedPuzzles, setSolvedPuzzles] = useState(1);
  const [curtisSolved, setCurtisSolved] = useState(false);
  const [frankSolved, setFrankSolved] = useState(false);
  const [davisSolved, setDavisSolved] = useState(false);
  const [mattSolved, setMattSolved] = useState(false);
  const [ajSolved, setAjSolved] = useState(false);
  const [lucaSolved, setLucaSolved] = useState(false);
  const [gregSolved, setGregSolved] = useState(false);

  const [state, setState] = useState(Array(7).fill(false));
  const [status, setStatus] = useState("");

  // Notification state
  const [notification, setNotification] = useState(null);

  // Helper to show notification
  const showNotification = (isCorrect) => {
    setNotification({
      message: isCorrect ? "Password correct!" : "Password incorrect",
      type: isCorrect ? "success" : "error",
    });

    setTimeout(() => setNotification(null), 3000);
  };

  // Fetch current state on startup
  useEffect(() => {
    const fetchState = async () => {
      try {
        const res = await fetch("https://backend-icy-sky-7649.fly.dev");
        const data = await res.json();

        setState(data.state);
        setStatus(data.status);

        const numSolved = data.state.filter(Boolean).length + 1;
        setSolvedPuzzles(numSolved);
        setCurtisSolved(numSolved > 1);
        setFrankSolved(numSolved > 2);
        setDavisSolved(numSolved > 3);
        setMattSolved(numSolved > 4);
        setAjSolved(numSolved > 5);
        setLucaSolved(numSolved > 6);
        setGregSolved(numSolved > 7);
      } catch (err) {
        console.error("Error fetching state:", err);
      }
    };
    fetchState();
  }, []);

  // Handle backend response from password attempts
  const handleResponse = (data) => {
    const prevSolved = solvedPuzzles;
    const newSolved = data.state.filter(Boolean).length + 1;

    // Update state
    setState(data.state);
    setSolvedPuzzles(newSolved);

    setCurtisSolved(newSolved > 1);
    setFrankSolved(newSolved > 2);
    setDavisSolved(newSolved > 3);
    setMattSolved(newSolved > 4);
    setAjSolved(newSolved > 5);
    setLucaSolved(newSolved > 6);
    setGregSolved(newSolved > 7);

    // Show notification: correct if numSolved increased
    const isCorrect = newSolved > prevSolved;
    showNotification(isCorrect);
  };

  return (
    <div className="unlock-root">
      <div className="header">
        <div className="title">Official Batman Fanclub</div>
        <div
          className="map-tab"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <button
            className={activeTab === "map" ? "active" : ""}
            onClick={() => setActiveTab("map")}
          >
            Map
          </button>
        </div>
        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}
            className="wizard-button">
            <button onClick={() => setActiveTab("wizard")}>HELP</button>
          </div>
      </div>

      <div className="tab-content" style={{ height: "100%" }}>
        {activeTab === "map" && (
          <Map setActiveTab={setActiveTab} solvedPuzzles={solvedPuzzles} onResponse={handleResponse} />
        )}
        {activeTab === "Start" && <Clue1 />}
        {activeTab === "Curty's Kookie" && (
          <Curtis solved={curtisSolved} onResponse={handleResponse} />
        )}
        {activeTab === "Track" && (
          <Frank solved={frankSolved} onResponse={handleResponse} />
        )}
        {activeTab === "Maintenance Hangar" && (
          <Davis solved={davisSolved} onResponse={handleResponse} />
        )}
        {activeTab === "Recording Studio" && (
          <Matt solved={mattSolved} onResponse={handleResponse} />
        )}
        {activeTab === "Psychiatric Hospital" && (
          <Aj solved={ajSolved} onResponse={handleResponse} />
        )}
        {activeTab === "Caves" && (
          <Caves solved={lucaSolved} onResponse={handleResponse} />
        )}
        {activeTab === "Gym" && (
          <Greg solved={gregSolved} onResponse={handleResponse} />
        )}
        {activeTab === "???" && (
          <Final/>
        )}
        {activeTab === "wizard" && (
          <Wizard/>
        )}
      </div>

      {/* Notification */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
}
